module.exports = __webpack_public_path__ + "fonts/SourceSansPro-ExtraLight.23a4c2de.ttf";